export default "__VITE_ASSET__C3rqYy2U__"